
const SCROLL_TOP = 380;
const TOP_NAV = 126;
const NAV_HEIGHT = 66;
const SCROLL_BOTTOM = 1565;
export default {
  mouseScrollNav(param, self) {
    if (param == null) {
      return;
    }
    let scrollTop = param.scrollTop;
    if (scrollTop < (SCROLL_TOP)) {
      self.secondNavFixed = false;
      return;
    }
    self.secondNavFixed = true;
  },
  mouseScrollVert(param, self) {
    if (param == null) {
      return;
    }
    let scrollTop = param.scrollTop;
    if (scrollTop < (SCROLL_TOP) || scrollTop > (SCROLL_BOTTOM)) {
      self.secondNavFixed = false;
      return;
    }
    self.secondNavFixed = true;
  },
  mouseScroll(param, self) {
    if (param == null) {
      return;
    }
    let scrollTop = param.scrollTop;

    if (scrollTop < (SCROLL_TOP)) {
      self.secondNavFixed = false;
      return;
    }
    self.secondNavFixed = true;

    for (let i = 1; i < self.AnchorsItems.length; i++) {
      let anchor = self.$el.querySelector(`#anchor-${i}`);
      if (scrollTop < anchor.offsetTop - 150) {
        self.indexActive = i - 1;
        return;
      }
    }
    self.indexActive = self.AnchorsItems.length - 1;
  },
  mouseScrollSoft(param, self) {
    if (param == null) {
      return;
    }
    let scrollTop = param.scrollTop;

    for (let i = 1; i <= self.AnchorsItems; i++) {
      let anchor = self.$el.querySelector(`#anchor-${i}`);
      if (scrollTop < (anchor.offsetTop + 150)) {
        self.indexActive = i;
        return;
      }
      if (scrollTop === 0) {
        self.indexActive = 1;
        return;
      }
    }
    self.indexActive = self.AnchorsItems;
  },
  mouseClick(selector, index, self, noBanner) {
    self.indexActive = index;
    let anchor = self.$el.querySelector(selector);
    let offsetTop = anchor.offsetTop - TOP_NAV;
    if (noBanner) {
      offsetTop += (TOP_NAV - NAV_HEIGHT);
    }
    if (index === 0 && !noBanner) {
      this.setScrollTop(SCROLL_TOP);
      return;
    }
    this.setScrollTop(offsetTop);
  },
  setScrollTop(height) {
    if (document && document.documentElement) {
      document.documentElement.scrollTop = height;
    }
    if (window && window.pageYOffset) {
      window.pageYOffset = height;
    }
    if (document && document.body) {
      document.body.scrollTop = height;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/solution/panels/js/HandleAnchor.js